import { Component } from 'preact'
import { withNamespaces } from 'react-i18next'
import styles from './ShoppingCartItem.scss'

class ShoppingCartItem extends Component {
    render({ room }) {

        const { t } = this.props

        return (
            <div class={styles.shoppingCartItem}>
                <div class={styles.title}>{room.name}</div>

                <div class={styles.roomWrapper}>
                    <div class={styles.roomInfo}>
                        {t('ShoppingCartItem.rooms') + ' '}
                        <span class={styles.roomInfoPrice}>
                            {room.count} x {room.price} {room.currency}
                        </span>
                    </div>

                    <div class={styles.price}>{room.totalPrice.toFixed(2)} {room.currency}</div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(ShoppingCartItem)


// WEBPACK FOOTER //
// ./components/ShoppingCart/ShoppingCartItem/ShoppingCartItem.js